/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Col_MethodInputs */

const en_audit_col_method = /** @type {(inputs: Audit_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Method`)
};

const pt_br2_audit_col_method = /** @type {(inputs: Audit_Col_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Método`)
};

/**
* | output |
* | --- |
* | "Method" |
*
* @param {Audit_Col_MethodInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_col_method = /** @type {((inputs?: Audit_Col_MethodInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Col_MethodInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_col_method(inputs)
	return pt_br2_audit_col_method(inputs)
});